import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner, Table } from "react-bootstrap";
import {
  NoDataFoundTable,
  PageLoader,
} from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { useParams } from "react-router";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const PullSDAData = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  getStudyCDISCSDA,
}) => {
  const { studyId } = useParams();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pullLibraryData, setPullLibraryData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const getCDISCSDA = async () => {
    try {
      setLoading(true);
      const data = await cdiscManagementService.getCDISCSDA();
      const rows = data?.data || [];
      setPullLibraryData(rows);
      setSelectedRows([]);
      setSelectAll(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (studyId) {
      getCDISCSDA();
    }
  }, [studyId]);

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    if (checked) {
      const allIds = pullLibraryData.map((item) => item.sdaId);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) => {
      const isSelected = prev.includes(id);
      const updated = isSelected ? prev.filter((x) => x !== id) : [...prev, id];
      setSelectAll(updated.length === pullLibraryData.length);
      return updated;
    });
  };

  const pullStudyCDISCSDA = async () => {
    setButtonLoader(true);
    const userData = {
      sdaIds: selectedRows,
      studyId,
    };
    const data = await cdiscManagementService.pullStudyCDISCSDA(userData);
    if (data?.statusCode === 200) {
      Hide();
      getStudyCDISCSDA();
      getCDISCSDA();
      setSelectedRows([]);
    }
    setButtonLoader(false);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} style={{ width: 975 }} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        {loading ? (
          <PageLoader />
        ) : pullLibraryData.length === 0 ? (
          <NoDataFoundTable MSG="SDA data not found!." />
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 bg-white">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    <Form.Check
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                  </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Source Data Label </th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Source Data Name</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Source Variable Name</th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>Target Domain Label</th>
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>Target Domain Name</th>
                    <th onMouseDown={(e) => onMouseDown(e, 5)}>Target Variable Label</th>
                    <th onMouseDown={(e) => onMouseDown(e, 6)}>Target Variable Name</th>
                    <th onMouseDown={(e) => onMouseDown(e, 8)}>Source Variable Type</th>
                </tr>
              </thead>
              <tbody>
                {pullLibraryData.map((item) => {
                  const rowId = item.sdaId;
                  return (
                    <tr key={rowId}>
                      <td className="text-center">
                        <Form.Check
                          type="checkbox"
                          checked={selectedRows.includes(rowId)}
                          onChange={() => handleRowSelect(rowId)}
                        />
                      </td>
                      <td>{item.sourceDatasetLabel}</td>
                      <td>{item.sourceDatasetName}</td>
                      <td>{item.sourceVariableName}</td>
                      <td>{item.targetDomainLabel}</td>
                      <td>{item.targetDomainName}</td>
                      <td>{item.targetVariableLabel}</td>
                      <td>{item.targetVariableName}</td>
                      <td>{item.sourceVariableType}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </>
        )}
      </Offcanvas.Body>

      <div className="p-2 border-top text-end">
        <button
          className="updateProfile"
          disabled={buttonLoader || selectedRows.length === 0}
          onClick={pullStudyCDISCSDA}
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Pulling...
            </div>
          ) : (
            Title
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default PullSDAData;
